import React, { useContext, useState } from "react";
import { SidebarContext } from "../context/SidebarContext";
import { MenuIcon, OutlineLogoutIcon, MoonIcon, SunIcon } from "../icons";
import {
  Dropdown,
  DropdownItem,
  WindmillContext,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
} from "@windmill/react-ui";
import { AuthContext } from "../context/AuthContext";
import {
  FaKeycdn,
  FaUserCircle,
  FaUsersCog,
  FaUserShield,
} from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../utils/useLocalStorage";

function Header() {
  const navigate = useNavigate();
  const { user, signOut } = useContext(AuthContext);
  const { toggleSidebar } = useContext(SidebarContext);

  const [isOpen, setIsOpen] = useState(false);

  function handleProfileClick() {
    setIsOpen(!isOpen);
  }

  // console.log(user);
  // Local storage
  const [selectedUser, setSelectedUser] = useLocalStorage("selectedUser");
  return (
    <>
      <header className="z-40 py-4 bg-white shadow-bottom dark:bg-gray-800">
        <div className="container flex items-center justify-between lg:justify-end h-full px-6 mx-auto text-primary dark:text-primary">
          {/* <!-- Mobile hamburger --> */}
          <button
            className="p-1 mr-5 -ml-1 rounded-md lg:hidden focus:outline-none focus:shadow-outline-primary"
            onClick={toggleSidebar}
            aria-label="Menu"
          >
            <MenuIcon className="w-6 h-6" aria-hidden="true" />
          </button>

          <ul className="flex items-center flex-shrink-0 space-x-6">
            {/* <!-- Profile menu --> */}
            <li className="relative">
              <button
                className="rounded-full focus:shadow-outline-primary focus:outline-none flex items-center"
                onClick={() => handleProfileClick()}
                // aria-label="Account"
                // aria-haspopup="true"
              >
                <FaUserCircle fill="#484750" size={20} />
                <span className="mx-3 text-gray-700 text-sm font-semibold">
                  {(user && user.username) ?? "USERNAME"}
                </span>
              </button>
              <Dropdown
                align="right"
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
              >
                {/* <DropdownItem
                  onClick={() => navigate(`/app/user/change-password-user`)}
                >
                  <RiLockPasswordFill
                    className="w-4 h-4 mr-3"
                    aria-hidden="true"
                  />
                  <span>Change Password</span>
                </DropdownItem> */}
                <DropdownItem
                  onClick={signOut}
                  // onClick={() => navigate("/login")}
                >
                  <OutlineLogoutIcon
                    className="w-4 h-4 mr-3"
                    aria-hidden="true"
                  />
                  <span>Log out</span>
                </DropdownItem>
              </Dropdown>
            </li>
          </ul>
        </div>
      </header>
    </>
  );
}

export default Header;
